import React from 'react'
import styled from "styled-components"
import {Link} from 'gatsby'

var Container = styled.img`
    /* font-family:'Roboto'; */
    width: 100%;
    height: 300px;
    color: #000000;
    text-align: center;
    position: relative;
    background-image:url("${props => props.src}");
    transition: all .5s ease-in-out; 
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
`

var EventsTitle = styled.div`
    font-size: 18px;
    margin: 0px;
    width: 100%;
    height: 60px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 8px;
    left: 0;
    bottom: 0%;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    color: #000000;
    @media screen and (max-width:500px){
        font-size: 13px;
    }
`

var EventsSubTitle = styled.div`
    font-size: 18px;
    margin: 0px;
    width: 100%;
    height: 24px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 8px;
    padding-block: 16px;
    left: 0;
    bottom: 0%;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    color: #000000;
    @media screen and (max-width:500px){
        font-size: 13px;
    }
`


var Boxhover = styled.div`
    width: 258px;
    // height: 380px;
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    margin: 5px;
    border: solid 1px rgba(15, 75, 84, 1);
    background: rgb(12, 232, 101, 0.1);
    // & :hover ${Container} {
    // transform: scale(1.05);
    // }
    @media screen and (max-width:500px){
        width: 90%;
    }
`
var Contentbox = styled.div`
    font-size: 20px;
    display: inline-grid;
    grid-gap: 5%;
    right: 0;
    left: 0;
    width: 100%;
`
var DateEventsCard = styled.p`
    font-size: 12px;
    color:#333333;
`
export default function EventsCard(props) {

    if(props.url){return (
        <Link to={props.url}>
            <Boxhover>
                <EventsSubTitle>{props.subtitle}</EventsSubTitle>
                <Container src={props.image} />
                <EventsTitle>{props.title}</EventsTitle>
            </Boxhover>
        </Link>
    
    )}
    // console.log("event", props)
    return (
        <Boxhover>
            <EventsSubTitle>{props.subtitle}</EventsSubTitle>
            <Container src={props.image} />
            <EventsTitle>{props.title}</EventsTitle>
        </Boxhover>
    )
}
